import request from '@/services/request'
import baseUrl from '@/services/baseUrl'

const path = `${baseUrl.main}/cs/v1/tickets/bo/`

export default {
  listEvents: (params = {}) => request.post(path + 'events', params),
  getEvent: id => request.post(`${path}events/${id}`, {}),
  setVisibility: (id, params = {}) => request.post(`${path}events/${id}/visibility`, params),
  listOrganizations: (params = {}) => request.post(path + 'organizations', params),
}
